module.exports = __webpack_public_path__ + "static/media/boris-400-400.a5ad53a7.png";